import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import App from './App';
import { ErrorBoundary } from './components/ErrorBoundary';
import { initMonitoring } from './lib/monitoring';
import { reportWebVitals } from './lib/web-vitals';
import './styles/globals.css';

initMonitoring();

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Root container #root not found');

createRoot(rootElement).render(
  <StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>,
);

reportWebVitals();
